import { scrollToSection } from "./sections";

export function initMenu() {
  const menuEl = document.querySelector('#menu');
  const menuLinks = document.querySelectorAll('#menu .menu a');
  const closeMenuButton = document.querySelector('#menu .close');
  const openMenuButton = document.querySelector('#intro .menu');

  const closeMenu = () => {
    menuEl.classList.remove('open');
  }
  const openMenu = (e) => {
    e.preventDefault();
    menuEl.classList.add('open');
  }

  openMenuButton.addEventListener("click", openMenu);
  closeMenuButton.addEventListener("click", closeMenu);

  menuLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const sectionName = e.target.getAttribute("href").replace("#", "");
      closeMenu();
      scrollToSection(sectionName);
    });
  })

  // About button
  document.querySelector('#intro .about').addEventListener("click", (e) =>{
    e.preventDefault();
    scrollToSection('about');
  });
}